/**
 * 生成 web 图片资源 URL（图片由统一接口生成）
 * @param {string} prompt 图片内容描述词
 * @param {string} size 尺寸: square_hd | square | portrait_4_3 | portrait_16_9 | landscape_4_3 | landscape_16_9
 */
export function imgUrl(prompt, size = 'landscape_16_9') {
  return `https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=${encodeURIComponent(
    prompt
  )}&image_size=${size}`
}
